import React from 'react';
import {connect} from 'react-redux';
import {newContent} from "../../../actions/contentActions";
import NewContentForm from "./NewContentForm";
import Paper from "@material-ui/core/Paper";
import ViewTitle from "../../../components/ViewTitle";
import withStyles from "@material-ui/core/styles/withStyles";
import CssBaseline from "@material-ui/core/CssBaseline";
import {ThemeProvider} from "@material-ui/core/styles";

import {theme} from '../../Dashboard/theme';
import Grid from "@material-ui/core/Grid";

let themeCustom = {
  ...theme,
};

const styles = theme => ({
  block: {
    display: 'block',
  },
  addUser: {
    marginRight: theme.spacing(1),
  },
  contentWrapper: {
    margin: '40px 16px',
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
    padding: '15px',
    paddingTop: '40px',
    paddingBottom: '40px'
  },
  textField: {
    minWidth: "200px"
  },
  textArea: {
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.fontSize + 1,
    width: "100%"
  },
});

class ContentNew extends React.Component {

  onSubmit = (formValues) => {
    this.props.newContent(formValues);
  };

  render() {
    const {classes} = this.props;
    return (
      <ThemeProvider theme={themeCustom}>
        <Grid container maxWidth="xs" style={{
          maxHeight: "100%",
          maxWidth: "100%",
          display: "flex",
          flexDirection: "column"
        }}>
          <CssBaseline/>
          <Grid container justify="center">
            <Paper className={classes.paper}>
              <ViewTitle>
                New content
              </ViewTitle>
              <NewContentForm
                onSubmit={this.onSubmit}
                classes={classes}
              />
            </Paper>
          </Grid>
        </Grid>
      </ThemeProvider>
    );
  }
}


ContentNew = connect(null, {newContent})(ContentNew);
ContentNew = withStyles(styles)(ContentNew);
export default ContentNew;
